import { connect } from 'react-redux';
import { updateMessage, sendMessage, addImages, removeImage } from '../../chat/modules/new-message';
import {
  loadMessages,
  loadPrevPage,
  onNewMessages,
  loadLastMessages,
  readMessages,
  toggleScrollToBottomEffect,
} from '../../chat/modules/load-messages';
import { setActiveChat } from '../../chat/modules/chat-actions';
import { openLightbox, closeLightbox } from '../../chat/modules/lightbox';
import {
  toggleChat,
  loadUnreadCount,
  setUnreadCount,
  updateChatInfo,
  toggleChatFullsize,
  toggleSelectChatRooms,
} from '../modules/chat-button';
import { saveDraftMessage } from '../../common/actions/chat';
import Chat from '../components/chat/Chat';

const mapDispatchToProps = {
  updateMessage,
  sendMessage,
  loadMessages,
  toggleScrollToBottomEffect,

  loadPrevPage,
  loadLastMessages,
  readMessages,
  addImages,
  removeImage,
  openLightbox,
  closeLightbox,
  toggleChat,
  loadUnreadCount,
  setUnreadCount,
  updateChatInfo,
  saveDraftMessage,
  toggleChatFullsize,
  toggleSelectChatRooms,
  onNewMessages,
  setActiveChat,
};

const mapStateToProps = state => ({
  currentUser: state.chat.currentUser,
  customerId: state.chat.customerId,
  chat: state.chat.chat,
  activeChatId: state.chat.activeChatId,
  chats: state.chat.chats,
  messages: state.chat.messages,
  message: state.chat.message,
  timestamp: state.chat.timestamp,
  labels: state.chat.labels,
  lightboxImage: state.chat.lightboxImage,
  visible: state.chat.visible,
  chatFullsize: state.chat.fullsize,
  chatSelectRoomOpen: state.chat.chatSelectRoomOpen,
  role: state.chat.role,
  unreadCount: state.chat.unreadCount,
  messagesInitialized: state.chat.messagesInitialized,
  messagesInitializationError: state.chat.messagesInitializationError,
  scrollToBottomEffect: state.chat.scrollToBottomEffect,
  inlineBadge: state.chat.inlineBadge,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Chat);



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/containers/ChatContainer.js